import React,{useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/Auth/Create'
import Cookies from 'js-cookie'
import { useState } from 'react';
import { Notification } from '../../sdk';
import moment from 'moment';
import { toasterFunction } from './ToasterComponent';
import { assetUrl } from '../../helpers';
export const Header=()=>{
	const userAuth=useAuthContext();
	const navigate=useNavigate();
	const [notification,setNotification]=useState({data:[],frCount:"",anprCount:"",countForNotification:0,personDetect:""});

    let userImg=`${assetUrl}/${userAuth.user.img}`
	const logout=()=>{
		Cookies.remove(`${process.env.NODE_ENV}-userToken`);
		localStorage.clear();
		userAuth.updateState(null);
		navigate("/login")
	}
	const getAllNotification=async ()=>{
		try{
			let data=await new Notification().getLimitNotification();
	        if(data.persondetect){
                let currentTimeUnix=moment().unix();
				const audio = new Audio("assets/audio/notification.wav");
				for(let val of data.data){
					let valueUnixTime=moment(val.createdAt).unix();
					let differance=Number(currentTimeUnix) - Number(valueUnixTime);
					if(val.viewStatus ===0 && differance <= 5){

						toasterFunction.success(val.text);
						audio.play();
					}
				}
				}
			setNotification({data:data.data,personDetect:data.persondetect});
		}catch(e){
          console.log(e);
		}
	}
	const seeAllNotification=async (type)=>{
		try{
			await new Notification().seeAllNotification(type);

			// navigate("/live-attendance");
			
		}catch(e){
          console.log(e);
		}
	}
	// useEffect(()=>{
	// 	getAllNotification();
	// 	const setTime=setInterval(()=>getAllNotification(),1000 *5)
	// 	return ()=>{
	// 	  clearInterval(setTime)
	// 	}
	// },[])
  return (
    <>
    <div id="header" className="app-header">
		
			<div className="desktop-toggler">
				<button type="button" className="menu-toggler" data-toggle-class="app-sidebar-collapsed" data-dismiss-class="app-sidebar-toggled" data-toggle-target=".app">
					<span className="bar"></span>
					<span className="bar"></span>
					<span className="bar"></span>
				</button>
			</div>
		
			<div className="mobile-toggler">
				<button type="button" className="menu-toggler" data-toggle-class="app-sidebar-mobile-toggled" data-toggle-target=".app">
					<span className="bar"></span>
					<span className="bar"></span>
					<span className="bar"></span>
				</button>
			</div>
			
			<div className="brand">
				<a href="index.html" className="brand-logo">
					<span >
						<img src='assets/img/logo.png' alt='alt' style={{width:"30%"}}/> 
					</span>
					
				</a>
			</div>
			{/* <!-- END brand -->
			
			<!-- BEGIN menu --> */}
			<div className="menu">
				{/* <div className="menu-item dropdown">
					<a href="#" data-toggle-class="app-header-menu-search-toggled" data-toggle-target=".app" className="menu-link">
						<div className="menu-icon"><i className="bi bi-search nav-icon"></i></div>
					</a>
				</div> */}
				{/* <div className="menu-item dropdown dropdown-mobile-full">
					<a href="#" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link">
						<div className="menu-icon"><i className="bi bi-grid-3x3-gap nav-icon"></i></div>
					</a>
					<div className="dropdown-menu fade dropdown-menu-end w-300px text-center p-0 mt-1">
						<div className="row row-grid gx-0">
							<div className="col-4">
								<a href="email_inbox.html" className="dropdown-item text-decoration-none p-3 bg-none">
									<div className="position-relative">
										<i className="bi bi-circle-fill position-absolute text-theme top-0 mt-n2 me-n2 fs-6px d-block text-center w-100"></i>
										<i className="bi bi-envelope h2 opacity-5 d-block my-1"></i>
									</div>
									<div className="fw-500 fs-10px text-white">INBOX</div>
								</a>
							</div>
							<div className="col-4">
								<a href="pos_customer_order.html" target="_blank" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-hdd-network h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">POS SYSTEM</div>
								</a>
							</div>
							<div className="col-4">
								<a href="calendar.html" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-calendar4 h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">CALENDAR</div>
								</a>
							</div>
						</div>
						<div className="row row-grid gx-0">
							<div className="col-4">
								<a href="helper.html" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-terminal h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">HELPER</div>
								</a>
							</div>
							<div className="col-4">
								<a href="settings.html" className="dropdown-item text-decoration-none p-3 bg-none">
									<div className="position-relative">
										<i className="bi bi-circle-fill position-absolute text-theme top-0 mt-n2 me-n2 fs-6px d-block text-center w-100"></i>
										<i className="bi bi-sliders h2 opacity-5 d-block my-1"></i>
									</div>
									<div className="fw-500 fs-10px text-white">SETTINGS</div>
								</a>
							</div>
							<div className="col-4">
								<a href="widgets.html" className="dropdown-item text-decoration-none p-3 bg-none">
									<div><i className="bi bi-collection-play h2 opacity-5 d-block my-1"></i></div>
									<div className="fw-500 fs-10px text-white">WIDGETS</div>
								</a>
							</div>
						</div>
					</div>
				</div> */}
		{/* <div className="menu-item dropdown dropdown-mobile-full">
        <a href="#" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link">
          <div className="menu-icon" onClick={()=>seeAllNotification("anpr")}><i className="fas fa-car" /></div>
          <div><p style={{color:"red",fontSize:"20px"}}>{notification.anprCount?notification.anprCount:""}</p> </div>
        </a>
        <div className="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1">
          <h6 className="dropdown-header fs-10px mb-1">NOTIFICATIONS</h6>
          <div className="dropdown-divider mt-1" />
		  {notification.data.filter(val=>val.type==="anpr").map((val)=>{
			return (<>
			 <a onClick={()=>{
				navigate("/anpr-report")
			 }} className="d-flex align-items-center py-10px dropdown-item text-wrap">
			 <div className="fs-20px">
			 <i class="fa fa-user" aria-hidden="true"></i>
			 </div>
			 <div className="flex-1 flex-wrap ps-3">
			   <div className="mb-1 text-white">{val.text}</div>
			   <div className="small">{moment(val.createdAt).fromNow()}</div>
			 </div>
		   
		   </a>
			</>)
			
		  })}
		  <hr className="bg-white-transparent-5 mb-0 mt-2" />
						<div className="py-10px mb-n2 text-center">
							<a  className="text-decoration-none fw-bold" style={{cursor:"pointer"}} onClick={()=>{
								navigate("/notifications/anpr")
							}}>SEE ALL</a>
						</div>
         
     
        </div>
      </div>		 */}
		{/* <div className="menu-item dropdown dropdown-mobile-full">
        <a href="#" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link">
          <div className="menu-icon" onClick={()=>seeAllNotification("persondetect")}><i className="fa fa-smile" /></div>
          <div><p style={{color:"red",fontSize:"20px"}}>{notification.personDetect?notification.personDetect:""}</p> </div>
        </a>
        <div className="dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1">
          <h6 className="dropdown-header fs-10px mb-1">NOTIFICATIONS</h6>
          <div className="dropdown-divider mt-1" />
		  {notification.data.filter(val=>val.type==="persondetect").map((val)=>{
			return (<>
			 <a onClick={()=>{
				navigate("/live-attendance")
			 }} className="d-flex align-items-center py-10px dropdown-item text-wrap">
			 <div className="fs-20px">
			 <i class="fa fa-user" aria-hidden="true"></i>
			 </div>
			 <div className="flex-1 flex-wrap ps-3">
			   <div className="mb-1 text-white">{val.text}</div>
			   <div className="small">{moment(val.createdAt).fromNow()}</div>
			 </div>
		   
		   </a>
			</>)
			
		  })}
           <hr className="bg-white-transparent-5 mb-0 mt-2" />
						
     
        </div>
      </div> */}
				<div className="menu-item dropdown dropdown-mobile-full">
					<a href="#" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link">
						<div className="menu-img online">
							<img src={userImg} alt="Profile" height="60" />
						</div>
						<div className="menu-text d-sm-block d-none">{userAuth.user.name}</div>
					</a>
					<div className="dropdown-menu dropdown-menu-end me-lg-3 fs-11px mt-1">
						<div className="dropdown-item d-flex align-items-center">{userAuth.user.role}</div>
						<div className="dropdown-divider"></div>
						<a className="dropdown-item d-flex align-items-center" onClick={logout}>LOGOUT <i className="bi bi-toggle-off ms-auto text-theme fs-16px my-n1"></i></a>
					</div>
				</div>
			</div>
		
			<form className="menu-search" method="POST" name="header_search_form">
				<div className="menu-search-container">
					<div className="menu-search-icon"><i className="bi bi-search"></i></div>
					<div className="menu-search-input">
						<input type="text" className="form-control form-control-lg" placeholder="Search menu..." />
					</div>
					<div className="menu-search-icon">
						<a href="#" data-toggle-class="app-header-menu-search-toggled" data-toggle-target=".app"><i className="bi bi-x-lg"></i></a>
					</div>
				</div>
			</form>
			
		</div>
    </>
  )
}
